import * as React from 'react';
export const CustomNoResultsComponentContext = React.createContext(null);
export const CustomNoResultsComponentContextProvider = CustomNoResultsComponentContext.Provider;
